import { Box, Container, Stack, Typography } from "@mui/material";

import { Section } from "..";
import { GetStarted } from ".";

const Pricing = ({ prices }) => (
  <Container disableGutters maxWidth="large">
    <Section
      py={4}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <div>
        <Typography
          paragraph
          align="center"
          component="div"
          variant="displayMd"
          color="dark.primary.color"
        >
          Affordable at scale
        </Typography>
      </div>
      <div>
        <Typography
          paragraph
          align="center"
          variant="headlineSm"
          color="dark.secondary.color"
        >
          Example prices
        </Typography>
        <Stack
          useFlexGap
          flexWrap="wrap"
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="space-around"
        >
          {[
            ["Small", 0.1, prices.sm],
            ["Medium", 1, prices.md],
            ["Large", 7, prices.lg],
            ["XL", 70, prices.xl]
          ].map(([shirt, size, model], index) => (
            <Box
              key={index}
              width={{ compact: "100%", expanded: "24%" }}
              bgcolor="dark.surface.container.lowest"
              p={3}
              sx={theme => ({ borderRadius: theme.shape.md.round })}
            >
              <Typography variant="headlineSm" color="dark.primary.color">
                {shirt} models
              </Typography>
              <Typography
                paragraph
                variant="titleMd"
                color="dark.secondary.color"
              >
                (e.g. {size} billion params)
              </Typography>

              <Typography
                component="div"
                variant="titleMd"
                color="dark.secondary.color"
              >
                {model?.name}
              </Typography>
              <Typography
                component="div"
                variant="bodySm"
                color="dark.secondary.color"
              >
                {`${model?.ramRequired?.toFixed(1)} gb required`}
              </Typography>
              <Typography
                component="div"
                variant="titleLg"
                color="colors.success.80"
              >
                {`$${(model?.ramRequired * 0.0000166667).toFixed(5)} / sec`}
              </Typography>
            </Box>
          ))}
        </Stack>
        <Box
          mt={1}
          bgcolor="dark.surface.container.lowest"
          p={3}
          sx={theme => ({ borderRadius: theme.shape.md.round })}
        >
          <Typography variant="headlineMd" color="dark.surface.on.color">
            vs GPT 4o
          </Typography>
          <Typography paragraph variant="bodyLg" color="dark.surface.on.color">
            Closed source is great. Open source, fine-tuned is awesome.
          </Typography>
          <Typography
            component="div"
            variant="titleLg"
            color="dark.surface.on.color"
          >
            Open source 70 billion param, fine-tuned model, 4-bit quantized
          </Typography>
          <Typography
            paragraph
            component="div"
            variant="titleLg"
            color="colors.success.80"
          >
            {`$${((prices.xl.ramRequired / 8) * 0.0000166667).toFixed(
              4
            )} / sec`}
          </Typography>
          <Typography variant="titleLg" color="dark.surface.on.color">
            GPT-4o
          </Typography>
          <Typography
            component="div"
            variant="titleLg"
            color="dark.tertiary.color"
          >
            {`$0.0015 / sec`}
          </Typography>
          <Typography variant="bodySm" color="dark.secondary.color">
            {`calculated at 100 tokens per second, $15 per 1m tokens`}
          </Typography>
        </Box>
      </div>
      <Stack
        py={2}
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-around"
        direction="row"
      >
        <div>
          <Typography
            component="div"
            color="dark.surface.on.color"
            typography={{ compact: "headlineLg", expanded: "displayLg" }}
          >
            Serverless AI
          </Typography>
          <Typography
            paragraph
            color="dark.secondary.color"
            fontWeight={"100 !important"}
            typography={{ compact: "headlineLg", expanded: "displayLg" }}
          >
            $0.0000166667 / gb sec
          </Typography>
        </div>
        <GetStarted />
      </Stack>
    </Section>
  </Container>
);

export default Pricing;
